import React from 'react';

/**
 * ConversionTrustIndicators
 *
 * Static trust/credibility cards shown below the social proof section.
 */
const ConversionTrustIndicators = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div className="text-center p-6 bg-blue-50 rounded-xl">
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-6 h-6 text-blue-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
            />
          </svg>
        </div>
        <h4 className="font-bold text-gray-900 mb-2">DOE Certified</h4>
        <p className="text-sm text-gray-600">
          US Department of Energy Industrial Assessment Center methodology
        </p>
      </div>

      <div className="text-center p-6 bg-green-50 rounded-xl">
        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-6 h-6 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
            />
          </svg>
        </div>
        <h4 className="font-bold text-gray-900 mb-2">Money-Back Guarantee</h4>
        <p className="text-sm text-gray-600">
          90-day full refund if you&apos;re not completely satisfied
        </p>
      </div>

      <div className="text-center p-6 bg-purple-50 rounded-xl">
        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-6 h-6 text-purple-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        </div>
        <h4 className="font-bold text-gray-900 mb-2">Fast Delivery</h4>
        <p className="text-sm text-gray-600">
          Professional report delivered within 48 hours guaranteed
        </p>
      </div>
    </div>
  );
};

export default ConversionTrustIndicators;


